import { SET_DATA_KEY } from '../../constants'

export function updateWeightSetDataUtil (set, value) {
  return {
    ...set,
    [SET_DATA_KEY.WEIGHT]: value
  }
}
